import React from 'react';
import './index.css';
import { PRIVACY_POLICY_PAGE, CONTACT_EMAIL } from '../../constants'
import { Link } from 'react-router-dom';
import { Icon } from "@blueprintjs/core";

class Footer extends React.Component {

  render() {
    return (
      <div className="Footer">
        <div className="Footer-element flex-center-row">
          <Icon icon="heart" className="Footer-icon"/>
          <a href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
        </div>
        <span className="pt-navbar-divider separator"/>
        <div className="Footer-element flex-center-row">
          <Icon icon="manual" className="Footer-icon"/>
          <Link to={PRIVACY_POLICY_PAGE}>
            privacy policy
          </Link>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js